<form class="sign-in-sms-code" autocomplete="off" @submit.prevent="">
    <div v-show="showLoadingSpinner" class="spinner"></div>

    <div class="info-text" v-if="!smsResent">
        {{ $t('sign-in.sms-sent', {phoneMask: phoneMask}) }}
    </div>
    <div class="info-text" v-if="smsResent">
        {{ $t('sign-in.sms-resent', {phoneMask: phoneMask}) }}
    </div>

    <PinCodeComponent
        :value="smsCode"
        :length="SMS_CODE_LENGTH"
        placeholder=""
        @input="onSmsCodeInput"
    />

    <a v-if="!smsResendWaitTimeInSeconds" class="resend-sms-line" href="" v-on:click.prevent="onResendSmsClicked">{{ $t('sign-in.resend-sms') }}</a>
    <div v-if="smsResendWaitTimeInSeconds" class="resend-sms-line">{{ $t('sign-in.resend-sms-wait-time-seconds', {seconds: smsResendWaitTimeInSeconds}) }}</div>

</form>
<div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
